import { deserialize, DocumentObject } from '@jsonapiworld/jsonapi-serializer';
import { backendApiGateway } from '~/client/backend';
import { MetaDataCursorPage, pagedMetaSchema } from '~/types/jsonapi';
import { VATBook } from '~/types/vat-bookkeeping';
import { buildJsonAPIQueryParams, jsonAPICursorPaginatorBuilder, jsonAPIFilterBuilder } from '~/utils/jsonapi-query';

const vatBooksPageSize = 50;

export const fetchAllVATBooks = async (companyId: string): Promise<VATBook[]> => {
  let allBooks: VATBook[] = [];
  let fetchedBooks: VATBook[] = [];

  let cursor: MetaDataCursorPage['cursor'] | null = null;
  const filterBuilder = jsonAPIFilterBuilder();
  filterBuilder.eq('company.id', companyId);

  do {
    const pageBuilder = jsonAPICursorPaginatorBuilder({ size: vatBooksPageSize });
    if (cursor) pageBuilder.cursor(cursor);
    const searchParams = buildJsonAPIQueryParams(filterBuilder, pageBuilder);

    const { data: results } = await backendApiGateway.get<DocumentObject & { meta: { page: MetaDataCursorPage } }>(
      '/api/v1/vat-books',
      { params: searchParams },
    );

    fetchedBooks = deserialize<VATBook>(results) as VATBook[];
    allBooks = allBooks.concat(fetchedBooks);
    const { page } = pagedMetaSchema.parse(results.meta);
    cursor = page.cursor;
  } while (fetchedBooks.length === vatBooksPageSize);

  return allBooks;
};
